/**
 * Менеджер случайных фонов для приложения
 * Список фонов с радиальными градиентами
 */

const BACKGROUNDS = [
  { name: 'Amber', colors: ['#d9b245', '#bc8e31'] },
  { name: 'Aquamarine', colors: ['#60b196', '#4cacac'] },
  { name: 'Azure Blue', colors: ['#5cb0ca', '#4b96b4'] },
  { name: 'Battleship Grey', colors: ['#8b8b84', '#75756e'] },
  { name: 'Black', colors: ['#353637', '#000000'] },
  { name: 'Burgundy', colors: ['#a15d65', '#7e4a53'] },
  { name: 'Burnt Sienna', colors: ['#d66f3c', '#bf5030'] },
  { name: 'Camo Green', colors: ['#74934c', '#5e7c45'] },
  { name: 'Cappuccino', colors: ['#b1907e', '#8c7162'] },
  { name: 'Caramel', colors: ['#cf9832', '#be7f31'] },
  { name: 'Carmine', colors: ['#df574a', '#b94240'] },
  { name: 'Carrot Juice', colors: ['#da9666', '#cc7b55'] },
  { name: 'Celtic Blue', colors: ['#45b7ed', '#3b93df'] },
  { name: 'Chestnut', colors: ['#bd6e53', '#a35440'] },
  { name: 'Chocolate', colors: ['#a36d58', '#825144'] },
  { name: 'Cobalt Blue', colors: ['#6087ce', '#566dbf'] },
  { name: 'Copper', colors: ['#cf8656', '#ab6e3b'] },
  { name: 'Coral Red', colors: ['#d9886a', '#ca6f57'] },
  { name: 'Cyberpunk', colors: ['#858df2', '#866ddc'] },
  { name: 'Dark Lilac', colors: ['#b07ca4', '#976285'] },
  { name: 'Dark Green', colors: ['#506341', '#354d34'] },
  { name: 'Deep Cyan', colors: ['#30b4a9', '#209e9e'] },
  { name: 'Desert Sand', colors: ['#b29e81', '#8e8167'] },
  { name: 'Electric Indigo', colors: ['#a67ff2', '#7169df'] },
  { name: 'Electric Purple', colors: ['#c970c7', '#a465d0'] },
  { name: 'Emerald', colors: ['#77c585', '#51ab76'] },
  { name: 'English Violet', colors: ['#af84b9', '#92689d'] },
  { name: 'Fandango', colors: ['#e189b5', '#b66798'] },
  { name: 'Feldgrau', colors: ['#889187', '#6a756c'] },
  { name: 'Fire Engine', colors: ['#ef5e4f', '#d0434b'] },
  { name: 'French Blue', colors: ['#5b9ac3', '#427ea5'] },
  { name: 'French Violet', colors: ['#c160e6', '#9f53dc'] },
  { name: 'Grape', colors: ['#9c73c0', '#8258a9'] },
  { name: 'Gunmetal', colors: ['#4b5c62', '#36434b'] },
  { name: 'Gunship Green', colors: ['#548964', '#44715b'] },
  { name: 'Hunter Green', colors: ['#8dac77', '#5e8e63'] },
  { name: 'Indigo Dye', colors: ['#537890', '#466880'] },
  { name: 'Ivory White', colors: ['#bab6b0', '#a8a59e'] },
  { name: 'Jade Green', colors: ['#54c39b', '#43a683'] },
  { name: 'Khaki Green', colors: ['#abae6f', '#7d8b5d'] },
  { name: 'Lavender', colors: ['#b688e3', '#9766c8'] },
  { name: 'Lemongrass', colors: ['#acb85a', '#6f9e4b'] },
  { name: 'Light Olive', colors: ['#c1ae64', '#988c4e'] },
  { name: 'Malachite', colors: ['#94b457', '#549f54'] },
  { name: 'Marine Blue', colors: ['#4d679a', '#405384'] },
  { name: 'Midnight Blue', colors: ['#5b6884', '#414d65'] },
  { name: 'Mexican Pink', colors: ['#e26591', '#d05182'] },
  { name: 'Mint Green', colors: ['#7ecb82', '#56ab66'] },
  { name: 'Moonstone', colors: ['#7db0b3', '#63909a'] },
  { name: 'Mystic Pearl', colors: ['#d08a6d', '#b9666e'] },
  { name: 'Mustard', colors: ['#d3970d', '#c98111'] },
  { name: 'Navy Blue', colors: ['#6b9ddc', '#627bce'] },
  { name: 'Neon Blue', colors: ['#7494f8', '#6c71ea'] },
  { name: 'Onyx Black', colors: ['#4c5153', '#393d3f'] },
  { name: 'Old Gold', colors: ['#b58c38', '#9e7229'] },
  { name: 'Orange', colors: ['#d0993a', '#c67b44'] },
  { name: 'Pacific Cyan', colors: ['#59bca6', '#459fb5'] },
  { name: 'Pacific Green', colors: ['#6dc692', '#4aa888'] },
  { name: 'Persimmon', colors: ['#e6a55a', '#ce7a5d'] },
  { name: 'Pine Green', colors: ['#6aa87c', '#4b8574'] },
  { name: 'Pistachio', colors: ['#96af7b', '#6a8f5a'] },
  { name: 'Platinum', colors: ['#b0aca5', '#95908a'] },
  { name: 'Pure Gold', colors: ['#cbaa40', '#a78936'] },
  { name: 'Ranger Green', colors: ['#5f7849', '#455b40'] },
  { name: 'Rifle Green', colors: ['#64695c', '#535948'] },
  { name: 'Purple', colors: ['#ad6bad', '#915191'] },
  { name: 'Raspberry', colors: ['#de7a85', '#c36381'] },
  { name: 'Roman Silver', colors: ['#a3a8b5', '#878b96'] },
  { name: 'Rosewood', colors: ['#b67976', '#90595d'] },
  { name: 'Sapphire', colors: ['#58a3c8', '#5485c4'] },
  { name: 'Seal Brown', colors: ['#664d45', '#503c34'] },
  { name: 'Satin Gold', colors: ['#be9b47', '#9a803d'] },
  { name: 'Shamrock Green', colors: ['#89b062', '#639c4e'] },
  { name: 'Silver Blue', colors: ['#7fa3b7', '#69879c'] },
  { name: 'Sky Blue', colors: ['#58b2c8', '#5497c4'] },
  { name: 'Steel Grey', colors: ['#96a1ab', '#72808a'] },
  { name: 'Strawberry', colors: ['#dd8d6f', '#c36865'] },
  { name: 'Tactical Pine', colors: ['#43816a', '#356c69'] },
  { name: 'Tomato', colors: ['#e6783e', '#d85b40'] },
  { name: 'Turquoise', colors: ['#5dbeb6', '#469f9a'] }
];

/**
 * Получить случайный фон
 */
export function getRandomBackground() {
  const randomIndex = Math.floor(Math.random() * BACKGROUNDS.length);
  return BACKGROUNDS[randomIndex];
}

/**
 * Стили фона
 */
const BACKGROUND_STYLES = {
  rays: 'rays',           // Радиальные лучи (как на скриншоте)
  raysThick: 'raysThick', // Толстые лучи
  raysThin: 'raysThin',   // Тонкие лучи
  spiral: 'spiral',       // Спиральный эффект
  waves: 'waves',         // Волновой эффект
  radial: 'radial',       // Простой радиальный градиент
  mesh: 'mesh'            // Сетчатый эффект
};

/**
 * Получить случайный стиль фона
 */
function getRandomStyle() {
  const styles = Object.values(BACKGROUND_STYLES);
  return styles[Math.floor(Math.random() * styles.length)];
}

/**
 * Применить фон к элементу с различными эффектами
 * @param {HTMLElement} element - Элемент для применения фона
 * @param {Object} background - Объект фона с полями name и colors
 * @param {string} style - Стиль фона (по умолчанию случайный)
 */
export function applyBackground(element, background, style = null) {
  if (!element || !background) return;
  
  const [color1, color2] = background.colors;
  
  // Если стиль не указан, используем случайный или сохраняем выбранный
  if (!style) {
    try {
      const savedStyle = localStorage.getItem('glitchlings_background_style');
      style = savedStyle || getRandomStyle();
      if (!savedStyle) {
        localStorage.setItem('glitchlings_background_style', style);
      }
    } catch (e) {
      style = BACKGROUND_STYLES.rays;
    }
  }
  
  let gradient = '';
  
  switch (style) {
    case BACKGROUND_STYLES.rays:
      // Вариант 1: Радиальные лучи (16 лучей, средняя толщина)
      gradient = createRaysEffect(color1, color2, 16);
      break;
      
    case BACKGROUND_STYLES.raysThick:
      // Вариант 2: Толстые лучи (8 лучей)
      gradient = createRaysEffect(color1, color2, 8);
      break;
      
    case BACKGROUND_STYLES.raysThin:
      // Вариант 3: Тонкие лучи (24 луча)
      gradient = createRaysEffect(color1, color2, 24);
      break;
      
    case BACKGROUND_STYLES.spiral:
      // Вариант 4: Спиральный эффект
      gradient = createSpiralEffect(color1, color2);
      break;
      
    case BACKGROUND_STYLES.waves:
      // Вариант 5: Волновой эффект
      gradient = createWavesEffect(color1, color2);
      break;
      
    case BACKGROUND_STYLES.radial:
      // Вариант 6: Простой радиальный градиент
      gradient = createRadialEffect(color1, color2);
      break;
      
    case BACKGROUND_STYLES.mesh:
      // Вариант 7: Сетчатый эффект
      gradient = createMeshEffect(color1, color2);
      break;
      
    default:
      gradient = createRaysEffect(color1, color2, 16);
  }
  
  element.style.background = gradient;
  element.style.backgroundSize = '100% 100%';
  element.setAttribute('data-background', background.name);
  element.setAttribute('data-background-style', style);
}

/**
 * Создать эффект лучей
 */
function createRaysEffect(color1, color2, rayCount = 16) {
  const rayAngle = 360 / rayCount;
  const rayPattern = [];
  
  for (let i = 0; i < rayCount; i++) {
    const startAngle = i * rayAngle;
    const midAngle = startAngle + rayAngle / 2;
    const endAngle = startAngle + rayAngle;
    const isEven = i % 2 === 0;
    const rayColor = isEven ? color1 : color2;
    const rayColorAlt = isEven ? color2 : color1;
    
    rayPattern.push(`${rayColor} ${startAngle}deg`);
    rayPattern.push(`${rayColorAlt} ${midAngle}deg`);
    rayPattern.push(`${rayColor} ${endAngle}deg`);
  }
  
  const conicGradient = `conic-gradient(from 0deg, ${rayPattern.join(', ')})`;
  
  return `
    ${conicGradient},
    radial-gradient(circle at center, transparent 0%, ${color1}15 30%, ${color2}25 60%, ${color1}35 100%)
  `;
}

/**
 * Создать спиральный эффект
 */
function createSpiralEffect(color1, color2) {
  return `
    repeating-conic-gradient(from 0deg, ${color1} 0deg, ${color1} 15deg, ${color2} 15deg, ${color2} 30deg),
    radial-gradient(circle at center, ${color1}40 0%, ${color2}30 50%, ${color1}20 100%)
  `;
}

/**
 * Создать волновой эффект
 */
function createWavesEffect(color1, color2) {
  return `
    radial-gradient(ellipse at 20% 50%, ${color1}40 0%, transparent 50%),
    radial-gradient(ellipse at 80% 50%, ${color2}40 0%, transparent 50%),
    radial-gradient(ellipse at 50% 20%, ${color1}30 0%, transparent 40%),
    radial-gradient(ellipse at 50% 80%, ${color2}30 0%, transparent 40%),
    linear-gradient(135deg, ${color1} 0%, ${color2} 50%, ${color1} 100%)
  `;
}

/**
 * Создать простой радиальный эффект
 */
function createRadialEffect(color1, color2) {
  return `
    radial-gradient(circle at 20% 50%, ${color1}60 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, ${color2}60 0%, transparent 50%),
    radial-gradient(circle at center, ${color1} 0%, ${color2} 50%, ${color1} 100%)
  `;
}

/**
 * Создать сетчатый эффект
 */
function createMeshEffect(color1, color2) {
  return `
    repeating-linear-gradient(45deg, ${color1}20 0px, ${color1}20 20px, ${color2}20 20px, ${color2}20 40px),
    repeating-linear-gradient(-45deg, ${color1}15 0px, ${color1}15 20px, ${color2}15 20px, ${color2}15 40px),
    radial-gradient(circle at center, ${color1} 0%, ${color2} 100%)
  `;
}

/**
 * Получить текущий фон (Gunmetal для яркой темы)
 */
function getCurrentBackground() {
  // Возвращаем Gunmetal фон для яркой темы
  const gunmetalBg = BACKGROUNDS.find(b => b.name === 'Gunmetal');
  return gunmetalBg || BACKGROUNDS[0]; // Fallback на первый фон, если Gunmetal не найден
}

/**
 * Применить случайный фон ко всем экранам (только если прошло 24 часа)
 */
export function applyRandomBackgroundToHome() {
  const bg = getCurrentBackground();
  
  // Применяем фон ко всем экранам
  applyBackgroundToAllScreens(bg);
  
  // Если элементы ещё не загружены, пробуем через небольшую задержку
  setTimeout(() => {
    const screens = document.querySelectorAll('.screen, .glitchlings-home-screen, .glitchlings-battle-screen');
    if (screens.length > 0) {
      screens.forEach(screen => {
        applyBackground(screen, bg);
      });
    }
  }, 100);
}

/**
 * Применить сохранённый фон или случайный (только на главном экране)
 */
export function applySavedOrRandomBackground() {
  // Применяем фон только если мы на главном экране
  const homeScreen = document.querySelector('.glitchlings-home-screen');
  if (!homeScreen) {
    return null;
  }
  
  // Проверяем, активен ли главный экран
  const isHomeActive = homeScreen.classList.contains('active') || 
                       homeScreen.style.display !== 'none' ||
                       document.getElementById('home-screen')?.classList.contains('active');
  
  if (!isHomeActive) {
    // Не на главном экране - не применяем фон
    return null;
  }
  
  const bg = getCurrentBackground();
  applyBackground(homeScreen, bg);
  return bg;
}

/**
 * Применить фон ко всем экранам
 */
export function applyBackgroundToAllScreens(background) {
  if (!background) {
    background = getCurrentBackground();
  }
  
  // Применяем фон ко всем экранам
  const screens = document.querySelectorAll('.screen, .glitchlings-home-screen, .glitchlings-battle-screen');
  screens.forEach(screen => {
    applyBackground(screen, background);
  });
}

/**
 * Убрать фон (вернуть дефолтный) - больше не используется, фон применяется везде
 */
export function removeBackground() {
  // Фон теперь применяется на всех экранах, не убираем
  // Если нужно убрать, можно раскомментировать:
  // const screens = document.querySelectorAll('.screen, .glitchlings-home-screen');
  // screens.forEach(screen => {
  //   screen.style.background = '';
  //   screen.removeAttribute('data-background');
  // });
}

/**
 * Получить все доступные фоны
 */
export function getAllBackgrounds() {
  return BACKGROUNDS;
}

/**
 * Применить конкретный фон по имени
 */
export function applyBackgroundByName(name) {
  const bg = BACKGROUNDS.find(b => b.name === name);
  if (!bg) return false;
  
  const homeScreen = document.querySelector('.glitchlings-home-screen');
  if (homeScreen) {
    applyBackground(homeScreen, bg);
    
    // Сохраняем выбор
    try {
      localStorage.setItem('glitchlings_background', JSON.stringify(bg));
    } catch (e) {
      // Игнорируем ошибки
    }
    
    return true;
  }
  
  return false;
}

